import { getAccountAccessRanking } from 'api';
import Pagination from 'components/Pagination';
import { defaultPageSizeOptions } from 'constant/Pagination/pageSizeOption';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { useEffect, useState } from 'react';
import AccountAccessRankingTable from './AccountAccessRankingTable';
import { TableStyle } from './LayoutDefault/styled';

const AccountAccessRanking = ({
  filterData,
  pageSize,
  countToReset,
  setIsAccountsTableLoading,
  emptyText,
}) => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork } = useErrorNetworkMessage();

  const [pageNumber, setPageNumber] = useState(1);

  const { data: accountAccessRankingList = [], isLoading } = useQueryAPI({
    api: getAccountAccessRanking,
    key: 'getAccountAccessRankingList',
    params: {
      pageNumber,
      pageSize,
      dateFrom: filterData.dateFrom.format('YYYY-MM-DD'),
      dateTo: filterData.dateTo.format('YYYY-MM-DD'),
      keyword: filterData?.email,
    },
    enabled: filterData?.email !== null && filterData?.email !== undefined,
  });

  useEffect(() => {
    setPageNumber(1);
  }, [countToReset, pageSize]);

  useEffect(() => {
    setIsAccountsTableLoading(isLoading);
  }, [isLoading]);

  const handleChangePageNumber = (pageNumber) => {
    if (isOnline) {
      setPageNumber(pageNumber);
    } else {
      errorNetWork();
    }
  };

  return (
    <TableStyle>
      <AccountAccessRankingTable
        dataRaw={accountAccessRankingList?.data}
        isLoading={isLoading}
        emptyText={isLoading ? '集計中です。' : emptyText}
      />

      <Pagination
        currentPage={pageNumber}
        handlePagingChange={handleChangePageNumber}
        total={accountAccessRankingList?.data?.total}
        pageSize={pageSize}
        pageSizeOptions={defaultPageSizeOptions}
        isShowTotal={false}
      />
    </TableStyle>
  );
};

export default AccountAccessRanking;
